// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3p6cX","col":"Table_col__nb0xz","fulfillmentStatus":"Table_fulfillmentStatus__3wu8b","emailCol":"Table_emailCol__3XGLc"};